export default __webpack_public_path__ + "static/media/video-editing.1dd6369a.jpg";